import { Injectable } from '@angular/core';
import {
  DashboardResponse,
  OauthAEMConfig
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { timer } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { LoginFacadeHelperSuperSupportService } from './login-facade-helper-super-support.service';
@Injectable({
  providedIn: 'root'
})
export class LoginFacadeHelperSupportService extends LoginFacadeHelperSuperSupportService {
  getUserSessionDetails(): void {
    this.userData
      .getAuthConfigContent()
      .pipe(
        take(1),
        switchMap((authConfig: OauthAEMConfig) =>
          this.userSession.getUserSession().pipe(
            tap((response) => {
              if (
                response &&
                this.validateToolTipDisplay(
                  response.loggedIn as boolean,
                  authConfig
                )
              ) {
                this.tooltipUserIdentifier = response.smNumber;
                this.showAccountRecoveryPurchaseToolTip();
              }
            })
          )
        )
      )
      .subscribe(
        (res: DashboardResponse) => {
          this.isReady$.next(true);
          if (Object.entries(res).length != 0) {
            this.setDashboardResponseValues(res);
          } else {
            this.isLoggedIn$.next(false);
          }
        },
        (err) => {
          this.isReady$.next(true);
          this.loggingService.log('Caught Error: ' + err);
        }
      );
  }

  setDashboardResponseValues(res: DashboardResponse): void {
    this.loggedInDetails$.next({
      preferredName: res.preferredName,
      firstName: res.firstName,
      smBalance: res.smBalance,
      membershipLevel: res.membershipLevel
    });
    this.isWarmState$.next(res.isWarmState ? res.isWarmState : false);
    if (this.checkLoggedIn(res)) {
      this.loggedSetValues(res);
    } else {
      this.isLoggedIn$.next(false);
    }
  }

  loginTimeout(): void {
    if (this.APP_SESS_TIME_OUT) {
      timer(this.APP_SESS_TIME_OUT)
        .pipe(take(1))
        .subscribe(() => {
          if (this.APP_NAME !== 'checkout') {
            this.showSessionTimeoutModal = true;
          }
        });
    }
  }

  showAccountRecoveryPurchaseToolTip(): void {
    if (
      this.cookieHelper.getCookieValue(
        `hideAccountRecoveryTooltip_${this.tooltipUserIdentifier}`
      ) === null
    ) {
      this.updateToolTipToggle({
        displayAccountRecoveryToolTip: true
      });
    }
  }

  loggedSetValues(res: DashboardResponse): void {
    if (res.loggedIn) {
      this.isLoggedIn$.next(true);
      this.loginTimeout();
    } else {
      this.isLoggedIn$.next(false);
    }
  }
}
